import ChatDocuments from './ChatDocuments';

export default ChatDocuments;
